import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import { Link } from "react-router-dom";
import logo from "./logo.svg";
import "./Signup.css";
import Session from "react-session-api";
import ReturnClass from "./ReturnClass";
import { useState } from "react";
import { Form, Button } from 'semantic-ui-react';
import { useForm } from "react-hook-form";

export default function Signup() {

    const apiurl = window.SERVICE_URL;

    const characters = 'abcd1234';

    function generateString(length) {
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const captch = generateString(6)

    const checkCaptcha = () => {
        var element = document.getElementById("spcaptchaerror");
        var inputData = document.getElementById("inputType");
        var userc = document.getElementById("inputType").value;
        //element.innerHTML = "Checking....";
        inputData.disabled = true;
        element.disabled = true;

        if (userc.trim().length > 0) {
            if (captch == userc) {
                inputData.style.display = "none";
                return true;
            }
            else {
                //element.style.cursor = "not-allowed";
                //element.innerHTML = "Invalid Captcha!";
                //element.style.display = "block";
                var myFunction = function () {
                    inputData.disabled = false;
                    inputData.value = '';
                    element.style.display = "none";
                };
                setTimeout(myFunction, 5000);
                return false;
            }
        }
        else {
            //element.style.cursor = "not-allowed";
            //element.innerHTML = "Please Enter Captcha!";
            //element.style.display = "block";
            var myFunction = function () {
                inputData.disabled = false;
                inputData.value = '';
                element.style.display = "none";
            };
            setTimeout(myFunction, 5000);
            return false;
        }
    };

    const { register, handleSubmit, formState: { errors } } = useForm();

    const validatePassword = e => {

        var pwd = document.getElementById("Password").value;
        var confpwd = document.getElementById("ConfirmPassword").value;
        if (pwd != "" && confpwd != "") {
            if (pwd == confpwd) {
                var Password = document.getElementById("pwdSuc");
                Password.innerHTML = "Strong password";
                Password.style.color = "green";

            }
            else {
                var Password = document.getElementById("pwdSuc");
                Password.innerHTML = "password not matched";
                Password.style.color = "red";
            }
        }
        else {
            var Password = document.getElementById("pwdSuc");
            Password.innerHTML = "enter password";
            Password.style.color = "red";
        }
    }

    const navigate = useNavigate();

    const onSubmit = async (data, e) => {

        e.preventDefault();
        if (checkCaptcha()) {
            var fullname = document.getElementById("FullName").value;
            var password = document.getElementById("Password").value;
            var emailid = document.getElementById("EmailID").value;
            var mobnumber = document.getElementById("MobileNumber").value;
            var orgname = document.getElementById("OrganizationName").value;

            const signupForm = {
                PartnerID: "",
                FullName: fullname,
                UserName: "",
                Password: password,
                EmailID: emailid,
                MobileNumber: mobnumber,
                OrganizationName: orgname,
                Active: false,
                AddedOn: new Date(),
                IsMobileVerified: false,
                IsEmailVerified: false,
            };

            await axios
                .post(apiurl+`api/RegisterPartner`, signupForm, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((result) => {
                    console.log(result);
                    ReturnClass.OutMessage = result.data.outMessage;
                    ReturnClass.PartnerID = result.data.partnerID;
                    ReturnClass.EmailID = result.data.emailID;
                    ReturnClass.MobileNumber = result.data.mobileNumber;
                    ReturnClass.ID = result.data.id;
                    ReturnClass.PendingVerfication = result.data.pendingVerfication;
                    if (result.data.outMessage === "SuccessFully Registered !") {
                        if (result.data.pendingVerfication == 3) {
                            // Session.set("usersession", ReturnClass);
                            localStorage.setItem("usersession", JSON.stringify(ReturnClass));
                            navigate("/otp");
                        }
                    }
                    else if (result.data.outMessage === "You Are Already Registered With Us !") {
                        if (result.data.pendingVerfication == 3) {
                            //Session.set("usersession", ReturnClass);
                            localStorage.setItem("usersession", JSON.stringify(ReturnClass));
                            navigate("/otp");
                        }
                        else {
                            alert("You Are Already Registered Please Login !" + <a>Click Here</a>);
                        }
                    }
                });
        }
        else {
            alert('Invalid Captcha...');
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-4 px-5 py-2">
                    <center>
                        <img src={logo} alt="brand-logo" className="w-50 mb-3" />
                    </center>
                    <h3 align="center" className="title-subheading mb-5">
                        Sign Up To Questopedia
                    </h3>
                    <Form >
                        <Form.Field>
                            <label>First Name</label>


                            <input
                                type="text"
                                id="FullName"
                                className="form-control"
                                placeholder="Full Name"
                                name="FullName"
                                {...register("FullName", { required: true, maxLength: 200 })}
                            />
                        </Form.Field>
                        {errors.FullName && <p style={{ color: "red" }}>Please enter First Name</p>}

                        <Form.Field>
                            <label>Email</label>
                            <input
                                type="email"
                                id="EmailID"
                                className="form-control"
                                placeholder="Email"
                                name="EmailID"

                                {...register("EmailID",
                                    {
                                        required: true,
                                        pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                    })}
                            />

                        </Form.Field>
                        {errors.EmailID && <p style={{ color: "red" }}> Please enter valid Email</p>}


                        <Form.Field>
                            <label>Password</label>

                            <input
                                type="password"
                                id="Password"
                                className="form-control"
                                placeholder="Password."
                                name="Password"
                                {...register("Password", {
                                    required: true,

                                })}


                            />
                        </Form.Field>
                        {errors.Password && <p style={{ color: "red" }}>please enter Password</p>}


                        <Form.Field>
                            <div className="form-outline mb-1">
                                <label className="form-label" htmlFor="confirmpassword">
                                    ConfirmPassword
                                </label>
                                <input
                                    type="password"
                                    id="ConfirmPassword"
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    onChange={validatePassword}
                                />
                                <p id="pwdSuc"></p>
                            </div>
                        </Form.Field>
                        {errors.ConfirmPassword && <p style={{ color: "red" }}>please enter Confirm Password</p>}


                        <Form.Field>
                            <label> Mobile Number </label>

                            <input
                                type="text"
                                id="MobileNumber"
                                className="form-control"
                                placeholder="Mobile Number "
                                name="MobileNumber"
                                maxLength={10}
                                minLength={10}


                                {...register("MobileNumber", {
                                    required: true,
                                    pattern: /^(\+\d{1,3}[- ]?)?\d{10}$/

                                })}

                            />


                        </Form.Field>
                        {errors.MobileNumber && <p style={{ color: "red" }}>Please  enter valid Mobile Number</p>}

                        <Form.Field>
                            <label> Organization Name</label>

                            <input
                                type="text"
                                id="OrganizationName"
                                className="form-control"
                                placeholder="Organization Name"
                                name="OrganizationName"
                                {...register("OrganizationName", {
                                    required: true

                                })}

                            />


                        </Form.Field>
                        {errors.OrganizationName && <p style={{ color: "red" }}> Please enter Organization Name</p>}



                        <Form.Field>
                            <div className="row form-outline mb-3">
                                <div className="col-md-8">
                                    <input type="text" id="inputType" className="form-control" placeholder="Enter Captcha" name="username"
                                        autoComplete="off"
                                    />
                                    <span className="text-danger" id="spcaptchaerror"></span>
                                </div>
                                <div className="col-md-4">
                                    <div className='text-center alert-success px-2 py-1'>
                                        <h4 id="captcha" style={{ margin: "0", userSelect: "none" }} > {captch}</h4>
                                    </div>
                                </div>
                            </div>
                        </Form.Field>


                        <Button type='button' onClick={handleSubmit(onSubmit)}>Submit</Button>


                    </Form>

                    <div className="text-center">
                        <p>
                            Already Registered User?
                            <Link to="/"> Click here to login</Link>
                        </p>
                    </div>
                </div>
                <div className="col-md-8 rightbox">
                    <h3 className="title mt-3">Welcome to Questopedia</h3>
                    <div className="yoc-login__desc">
                        The Question Paper Generator Platform{" "}
                    </div>
                    <h6 className="brand-title" align="center">
                        Questopedia provides the services to care for business
                    </h6>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 1</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 2</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 3</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 4</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 5</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="feature-box">
                                <div className="iconbox">
                                    <i className="fa fa-newspaper-o"></i>
                                </div>
                                <h4 className="featureheading">faeture 6</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}